import { render } from "./Sitemap.vue?vue&type=template&id=3a5c384c"
import script from "./Sitemap.vue?vue&type=script&lang=js"
export * from "./Sitemap.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Sitemap.vue?vue&type=style&index=0&id=3a5c384c&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__